import { publicUserReq } from '@tshared/oapi/req/public-user-req'

import type { User } from '../models'

const DEFAULT_CLIENT_ID = 'DEFAULT'

export type SignInCredentials = {
  username: string
  password: string
}

export async function loginWithPassword(credentials: SignInCredentials): Promise<User | null> {
  const res = await publicUserReq.POST('/api/user/auth/login', {
    body: credentials,
  })

  return res.data?.data ?? null
}

export async function refreshAccessToken(refreshToken: string): Promise<User> {
  const res = await publicUserReq.POST('/api/user/auth/refresh-token', {
    body: {
      refreshToken,
      clientId: DEFAULT_CLIENT_ID,
    },
  })

  const user = res.data?.data
  if (!user?.accessToken) {
    throw new Error(res.data?.message ?? 'Failed to refresh user')
  }

  return user
}
